/**
 * Text size (My account › Profile): sets data-text-size on <html>, which the
 * root rule in theme/tokens.css turns into a root font size. Every font size
 * is rem by build time (postcss.config.js), so text scales and spacing stays.
 * The last choice is kept on this device too, so the first paint is right.
 */
export type TextSize = 'default' | 'large' | 'larger';

export const TEXT_SIZES: Array<{ value: TextSize; label: string }> = [
  { value: 'default', label: 'Default' },
  { value: 'large', label: 'Large (110%)' },
  { value: 'larger', label: 'Larger (120%)' },
];

const KEY = 'go.textSize';

export function isTextSize(v: unknown): v is TextSize {
  return v === 'default' || v === 'large' || v === 'larger';
}

export function applyTextSize(size: TextSize): void {
  const root = document.documentElement;
  if (size === 'default') delete root.dataset['textSize'];
  else root.dataset['textSize'] = size;
  try {
    if (size === 'default') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, size);
  } catch { /* storage blocked: the account setting still applies after sign-in */ }
}

/** Before the first render: the size this device last used. */
export function applyStoredTextSize(): void {
  let stored: string | null = null;
  try { stored = localStorage.getItem(KEY); } catch { stored = null; }
  if (isTextSize(stored) && stored !== 'default') document.documentElement.dataset['textSize'] = stored;
}
